import { pxTransform as TaroPxTransform } from "../_core/taro";
import { TaroEnv } from "./env";
export var pxTransform = function (size, designWidth) {
    if (TaroEnv) {
        return TaroPxTransform(size, designWidth);
    }
    return size + "px";
};
//# sourceMappingURL=px-transform.js.map